export const AppColors = {
  black: "#000",
  green: "green",
  red: "#DD4B4B",
  main: "#5ED5A8",
  white: "#fff",
};
